const QUALTRICS_PROD = {
  scriptUrl:
    'https://znbcovnabjyixpahd-paypaldigital.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_bCOVNaBJyiXPaHD',
  divId: 'ZN_bCOVNaBJyiXPaHD',
}

const QUALTRICS_STAGING = {
  scriptUrl:
    'https://zn1lngxfp069rsiay-paypaldigital.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_1LNgxfP069RsiaY',
  divId: 'ZN_1LNgxfP069RsiaY',
}

function getQualtricsConfig() {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
  return hostname === 'developer.paypal.com'
    ? QUALTRICS_PROD
    : QUALTRICS_STAGING
}

function getNonce(): string | undefined {
  if (typeof window === 'undefined') return undefined

  let nonce: string | undefined
  if (window.__INITIALDATA__?.attrs) {
    try {
      const attrsObj = JSON.parse(window.__INITIALDATA__.attrs)
      nonce = attrsObj.nonce
    } catch (e) {
      nonce = undefined
    }
  }
  if (!nonce) {
    nonce = window.__INITIALDATA__?.nonce || (window as any).nonce
  }
  return nonce
}

export function loadQualtricsScript(): void {
  const { scriptUrl, divId } = getQualtricsConfig()

  if (!scriptUrl) return

  const nonce = getNonce()

  // Ensure the div exists with the correct ID
  let qualtricsDiv = document.getElementById(divId)
  if (!qualtricsDiv) {
    qualtricsDiv = document.createElement('div')
    qualtricsDiv.id = divId
    document.body.appendChild(qualtricsDiv)
  }

  const existingScript = document.getElementById('qualtrics-script')
  if (existingScript) {
    existingScript.remove()
  }

  const scriptContent = `
    (function(){var g=function(g){this.go=function(){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)};this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};try{(new g("${scriptUrl}")).start()}catch(i){}})();
  `

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.id = 'qualtrics-script'
  script.setAttribute('nonce', nonce || '')
  script.innerHTML = scriptContent
  document.body.appendChild(script)
}
